<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-toolbar card color="white">
            <v-toolbar-title class="indigo--text">
              <v-toolbar-title class="indigo--text">
                Solicitudes de Cambio</v-toolbar-title
              ></v-toolbar-title
            >
          </v-toolbar>
          <!-- <template>
          <v-tabs >
            <v-tabs-slider :key="index" color="blue"></v-tabs-slider>
            <v-tab v-for="(tab,index) in tabs" :key="index" @click="selected(tab)">{{ tab }}</v-tab>
            <v-tabs-items> -->
          <!-- TAB DE Visita previa -->
          <!-- <v-card flat v-if="tabSelected=='Visita Prevista'">
                <visita-previa-tab :show="true" :tipeView="'consulta'" :contratoId="contratoId"></visita-previa-tab>
              </v-card> -->
          <!-- TAB DE Aplicacion dia 1 -->
          <!-- <v-card  flat v-if="tabSelected=='Aplicacion dia 1'">
                <aplicacion1-tab :show="true" :tipeView="'modifica'" :contratoId="contratoId"></aplicacion1-tab>
              </v-card> -->
          <!-- TAB DE Aplicacion dia 2 -->
          <!-- <v-card  flat v-if="tabSelected=='Aplicacion dia 2'">
                <aplicacion2-tab :show="true" :tipeView="'modifica'" :contratoId="contratoId"></aplicacion2-tab>
              </v-card>   -->
          <!-- TAB DE Aplicacion dia 2 -->
          <template>
            <div v-if="loading">
              <loading></loading>
            </div>
            <solicitudes-cambio-tab
              :show="true"
              :tipeView="'modifica'"
              :contratoId="contratoId"
            ></solicitudes-cambio-tab>
          </template>
          <!-- <v-card  flat v-if="tabSelected=='Solicitudes de cambio'">
                <solicitudes-cambio-tab :show="true" :tipeView="'modifica'" :contratoId="contratoId"></solicitudes-cambio-tab>
              </v-card>
            </v-tabs-items>
          </v-tabs>
        </template> -->
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Loading from "@/views/ui/Loading.vue";
import VisitaPreviaTab from "@/modules/aplicacion/views/seleccion/aplicacion/visitaPrevia/VisitaPreviaTab.vue";
import Aplicacion1Tab from "@/modules/aplicacion/views/seleccion/aplicacion/aplicacionDiaUno/AplicacionDia1.vue";
import Aplicacion2Tab from "@/modules/aplicacion/views/seleccion/aplicacion/aplicacionDiaDos/AplicacionDia2.vue";
import SolicitudesCambioTab from "@/modules/aplicacion/views/seleccion/aplicacion/solicitudesCambio/SolicitudesCambio.vue";

export default {
  name: "aplicacion-seleccion-tab",

  components: {
    Loading,
    VisitaPreviaTab,
    Aplicacion1Tab,
    Aplicacion2Tab,
    SolicitudesCambioTab,
  },

  props: {},

  data() {
    return {
      text: "En construccion",
      loading: false,
      proveedor: {},
      rowsTable: [20],
      contratoId: "",
      //tabs: [ "Solicitudes de cambio"],
      tabSelect: "",
      tabSelected: "",
      active_tab: "",
      index: "",
    };
  },

  mounted() {
    this.usuarioLogged = this.$store.getters.userLogged;
  },
  created() {
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.proceso = this.$store.getters.proSelectedStored;

    if (
      !this.$route.params.contratoId ||
      this.$route.params.contratoId == null ||
      this.$route.params.contratoId == ""
    ) {
      this.contratoId = this.$store.getters.contratoStored;
    } else {
      this.contratoId = this.$route.params.contratoId;
    }
    this.loadSelected();
  },

  methods: {
    loadSelected() {
      this.tabSelected = this.$store.getters.aplicacionTabSelectedStored;
    },
    selected(tab) {
      this.tabSelected = tab;
      this.$store.commit("sub_tab_state", tab);
    },
  },
};
</script>
